import { BACKEND_URL } from "../config";

const encodeParams = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.append(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

const API_BASE = BACKEND_URL;

const buildUrl = (path = "") => {
  if (/^https?:\/\//i.test(path)) return path;
  const prefix = path.startsWith("/") ? "" : "/";
  return `${API_BASE}${prefix}${path}`;
};

const request = async (method, url, config = {}) => {
  if (!API_BASE) {
    throw new Error(
      "API base URL is not configured. Set REACT_APP_API_BASE_URL to point to your backend."
    );
  }

  const { headers = {}, params, data } = config;
  let finalUrl = buildUrl(url || "");

  if (params && Object.keys(params).length) {
    const query = encodeParams(params);
    if (query) {
      finalUrl += finalUrl.includes("?")
        ? query.replace("?", "&")
        : query;
    }
  }

  const options = {
    method: method.toUpperCase(),
    headers: {
      Accept: "application/json",
      ...headers,
    },
  };

  const hasBody =
    data !== undefined &&
    data !== null &&
    options.method !== "GET";

  if (hasBody) {
    options.body =
      typeof data === "string" ? data : JSON.stringify(data);
    if (!options.headers["Content-Type"]) {
      options.headers["Content-Type"] = "application/json";
    }
  }

  const response = await fetch(finalUrl, options);

  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const error = new Error(
      (payload && payload.error) || response.statusText
    );
    error.response = {
      status: response.status,
      data: payload,
    };
    throw error;
  }

  return { data: payload, status: response.status };
};

const axios = {
  get: (url, config) => request("GET", url, config),
  post: (url, data, config = {}) =>
    request("POST", url, { ...config, data }),
  put: (url, data, config = {}) =>
    request("PUT", url, { ...config, data }),
  patch: (url, data, config = {}) =>
    request("PATCH", url, { ...config, data }),
  delete: (url, config) => request("DELETE", url, config),
};

export default axios;
export { API_BASE };
